import { LicenseForm } from '../components/LicenseForm';
import type { FormData } from '../types';

interface Props {
  data: FormData;
  onChange: (updates: Partial<FormData>) => void;
}

export function LicensesStep({ data, onChange }: Props) {
  return (
    <div>
      <div className="step-header">
        <h2>Licenses</h2>
        <p>Add any trade licenses or certifications your company holds. This step is optional.</p>
      </div>

      <LicenseForm
        licenses={data.licenses}
        onChange={(licenses) => onChange({ licenses })}
      />
    </div>
  );
}
